import { createSlice } from '@reduxjs/toolkit';

interface ILogoutTimeoutModalState {
  open: boolean;
}

const initialState: ILogoutTimeoutModalState = {
  open: false
};

const logoutTimeoutModalState = createSlice({
  name: 'logoutTimeoutModalState',
  initialState,
  reducers: {
    // there is no need to set a close function because when the user disconnect the state will set to false
    openModal(state) {
      state.open = true;
    }
  }
});

/*
|-----------------------------------------------------------------
| Export actions & reducer
|-----------------------------------------------------------------
|
*/

export const logoutTimeoutModalActions = {
  ...logoutTimeoutModalState.actions
};
export { default as logoutTimeoutModalSelectors } from './logoutTimeoutModal.selectors';

export default logoutTimeoutModalState.reducer;
